import { render } from "./Cases.vue?vue&type=template&id=7166d962&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=ts"
export * from "./Cases.vue?vue&type=script&lang=ts"

import "./Cases.vue?vue&type=style&index=0&id=7166d962&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7166d962"

export default script